import e from "@volumental/assets/logos/volumental-round.svg";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
import { clsx as i } from "clsx";
import { twMerge as a } from "tailwind-merge";
import o from "@volumental/assets/icons/backArrow.svg";
import s from "@volumental/assets/icons/closeCross.svg";
import { Fragment as c, createRef as l, forwardRef as u, useCallback as d, useEffect as f, useRef as p, useState as m } from "react";
import h from "@volumental/assets/icons/shrinkDropDown.svg";
import g from "@volumental/assets/icons/search.svg";
import _ from "@volumental/assets/icons/star.png";
import v from "@volumental/assets/icons/star_active.png";
import * as y from "@radix-ui/react-toggle-group";
import * as b from "@radix-ui/react-select";
import x from "@volumental/assets/icons/CheckmarkGreen.svg";
import S from "@volumental/assets/icons/Star_black.svg";
import * as C from "@radix-ui/react-radio-group";
import ee from "@volumental/assets/icons/checkMark.svg";
var w = { styles: {
	fontFamily: "'Lato', sans-serif",
	fontWeights: {
		bold: "700",
		regular: "400"
	},
	fontSizes: {
		regular: "1rem",
		medium: "1.125rem",
		large: "1.75rem",
		extraLarge: "2.25rem"
	},
	colors: {
		white: "#FFFFFF",
		black: "#000000",
		success: "#72E08D",
		error: "#e56a74",
		hidden: "rgba(0,0,0,0)",
		disabled: "rgba(0,0,0,0.10)",
		hint: "rgba(240, 227, 115, 0.60)"
	}
} };
//#endregion
//#region src/layout/footer.tsx
function T({ ariaLabel: t, altText: i, limitedBranding: a }) {
	return /* @__PURE__ */ n("footer", {
		className: "w-full h-14",
		"aria-label": t,
		children: a ? /* @__PURE__ */ n("div", {
			className: "flex flex-row mx-4 px-4 pb-4 pt-2 justify-center",
			children: /* @__PURE__ */ n("img", {
				src: e,
				alt: i,
				className: "h-6 w-auto"
			})
		}) : /* @__PURE__ */ r("div", {
			className: "flex flex-row items-center mx-4 px-4 pb-4 pt-2 font-normal justify-center",
			children: [/* @__PURE__ */ n("img", {
				src: e,
				alt: i,
				className: "h-5.25 w-auto"
			}), /* @__PURE__ */ r("p", {
				className: "ml-2 text-black text-xs",
				children: ["Powered by ", /* @__PURE__ */ n("strong", { children: "FitTech™ AI" })]
			})]
		})
	});
}
function E({ ariaLabel: t, altText: i, limitedBranding: a, children: o }) {
	return a ? /* @__PURE__ */ n("footer", {
		className: "mx-6 mb-6 mt-4",
		"aria-label": t,
		children: /* @__PURE__ */ n("div", {
			className: "font-normal px-4 py-4 text-black text-left bg-black/5 overflow-hidden backdrop-blur-md rounded-xl",
			children: /* @__PURE__ */ r("div", {
				className: "flex flex-row items-center gap-3",
				children: [/* @__PURE__ */ n("img", {
					src: e,
					alt: i,
					className: "h-6 w-auto"
				}), o]
			})
		})
	}) : /* @__PURE__ */ n("footer", {
		className: "mx-6 mb-6 mt-4",
		"aria-label": t,
		children: /* @__PURE__ */ r("div", {
			className: "font-normal px-4 py-4 text-black text-left bg-black/5 overflow-hidden backdrop-blur-md rounded-xl text-xs",
			children: [/* @__PURE__ */ r("div", {
				className: "flex flex-row items-center pb-3",
				children: [/* @__PURE__ */ n("img", {
					src: e,
					alt: i,
					className: "h-4 w-auto"
				}), /* @__PURE__ */ r("p", {
					className: "ml-1 text-black text-xs",
					children: ["Powered by ", /* @__PURE__ */ n("strong", { children: "FitTech™ AI" })]
				})]
			}), o]
		})
	});
}
function te({ text: e, link: i, linkText: a, onClickLink: o, ariaLabel: s, altText: c, link2: l, linkText2: u, limitedBranding: d, seperatorText: f }) {
	return /* @__PURE__ */ n(E, {
		ariaLabel: s,
		altText: c,
		limitedBranding: d,
		children: /* @__PURE__ */ r("div", { children: [
			e,
			/* @__PURE__ */ n("a", {
				href: i,
				className: "text-black px-0.75 font-bold",
				target: "_blank",
				rel: "noreferrer",
				onClick: o,
				children: a
			}),
			l && u ? /* @__PURE__ */ r(t, { children: [f, /* @__PURE__ */ n("a", {
				href: l,
				className: "text-black pl-0.75 font-bold",
				target: "_blank",
				rel: "noreferrer",
				children: u
			})] }) : void 0
		] })
	});
}
function D({ text: e, midText: i, privacyLink: a, privacyLinkText: o, termsLink: s, termsLinkText: c, organizationName: l, organizationPrivacyLink: u, onClickLink: d, ariaLabel: f }) {
	let p = !!(u && l);
	return /* @__PURE__ */ n("footer", {
		"aria-label": f,
		className: "my-4 text-xs",
		children: /* @__PURE__ */ r("div", {
			className: "text-black",
			children: [
				e,
				" ",
				p ? /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ r("a", {
					href: u,
					className: "text-black font-bold underline",
					target: "_blank",
					rel: "noopener noreferrer",
					onClick: d,
					children: [
						l,
						" ",
						o
					]
				}), ", "] }) : void 0,
				/* @__PURE__ */ r("a", {
					href: a,
					className: "text-black font-bold underline",
					target: "_blank",
					rel: "noreferrer",
					onClick: d,
					children: ["Volumental ", o]
				}),
				p ? ", " : " ",
				i,
				" ",
				/* @__PURE__ */ n("a", {
					href: s,
					className: "text-black font-bold underline",
					target: "_blank",
					rel: "noreferrer",
					onClick: d,
					children: c
				})
			]
		})
	});
}
//#endregion
//#region src/lib/cn.ts
function O(...e) {
	return a(i(e));
}
//#endregion
//#region src/layout/box-container.tsx
function k({ children: e, alignItems: t = "flex-start", marginTop: r = "24px", marginBottom: i = "12px", backgroundColor: a = "#f5f5f5", applyBorder: o = !1, padding: s = "25px" }) {
	return /* @__PURE__ */ n("div", {
		className: O("rounded-xl flex flex-col", o && "border border-black/10"),
		style: {
			marginTop: r,
			marginBottom: i,
			padding: s,
			background: a,
			alignItems: t
		},
		children: e
	});
}
//#endregion
//#region src/layout/container.tsx
function A({ children: e, backgroundColor: t = "#ffffff", className: r, style: i, ...a }) {
	return /* @__PURE__ */ n("div", {
		className: O("flex flex-col w-full h-dvh min-h-[-webkit-fill-available]", r),
		style: {
			background: t,
			...i
		},
		...a,
		children: e
	});
}
//#endregion
//#region src/layout/back-drop.tsx
function ne({ visible: e, animationTime: t = "0.6s", onClick: r }) {
	return /* @__PURE__ */ n("div", {
		"aria-hidden": !0,
		className: O("bg-black/50 w-full h-full backdrop-blur-[2px]", e ? "animate-sidebar-fade-in" : "animate-sidebar-fade-out"),
		style: { animationDuration: t },
		onClick: r
	});
}
//#endregion
//#region src/layout/content.tsx
function re({ children: e, justifyContent: t = "flex-start", disableGutters: r = !1, fitToContent: i = !1, disableScrollbar: a = !1, onScroll: o, className: s, style: c, ...l }) {
	return /* @__PURE__ */ n("div", {
		className: O("flex flex-auto flex-col grow overflow-y-scroll", r ? "px-0" : "px-6", i ? "max-h-[calc(100dvh-112px)]" : "h-[calc(100dvh-112px)]", a && "[&::-webkit-scrollbar]:hidden", s),
		style: {
			justifyContent: t,
			...c
		},
		onScroll: o,
		tabIndex: 0,
		...l,
		children: e
	});
}
//#endregion
//#region src/components/icon-button/icon-button.tsx
var j = u(({ iconSrc: e, altText: t, ...r }, i) => {
	let { type: a, disabled: o = !1 } = r;
	return /* @__PURE__ */ n("button", {
		className: "bg-transparent border-0 hover:cursor-pointer p-0 h-6 w-6 flex items-center justify-center text-center disabled:opacity-20",
		type: a === "submit" ? "submit" : "button",
		disabled: o,
		"aria-disabled": o,
		ref: i,
		...r,
		children: /* @__PURE__ */ n("img", {
			src: e,
			alt: t,
			className: "max-w-none"
		})
	});
});
j.displayName = "IconButton";
//#endregion
//#region src/layout/header.tsx
function M({ back: e, close: t, title: i, children: a, actions: c, ariaLabelBack: l, ariaLabelClose: u, altBack: d, altClose: f }) {
	return /* @__PURE__ */ r("div", {
		className: "grid grid-cols-[1fr_auto_1fr] h-14 items-center",
		children: [
			/* @__PURE__ */ r("div", {
				className: "flex items-center",
				children: [e ? /* @__PURE__ */ n("div", {
					className: "m-4",
					children: /* @__PURE__ */ n(j, {
						iconSrc: o,
						onClick: () => {
							e();
						},
						altText: d,
						"aria-label": l
					})
				}) : void 0, c?.map((e) => /* @__PURE__ */ n("button", {
					type: "button",
					className: "font-bold text-sm text-black border border-black/10 px-4 py-2 bg-transparent rounded-4xl ml-4",
					onClick: e.onClick,
					"aria-label": e.name,
					children: e.name
				}, e.name))]
			}),
			/* @__PURE__ */ n("div", {
				className: "flex items-center justify-center",
				children: i ? /* @__PURE__ */ n("div", {
					className: "text-black font-normal text-base text-center overflow-wrap-normal",
					role: "heading",
					"aria-level": 1,
					children: i
				}) : a
			}),
			/* @__PURE__ */ n("div", {
				className: "flex items-center justify-end",
				children: t ? /* @__PURE__ */ n("div", {
					className: "m-4",
					children: /* @__PURE__ */ n(j, {
						iconSrc: s,
						onClick: () => {
							t();
						},
						altText: f,
						"aria-label": u
					})
				}) : void 0
			})
		]
	});
}
//#endregion
//#region src/components/spinner/spinner.tsx
function N({ size: e = "15px" }) {
	return /* @__PURE__ */ n("div", {
		className: "rounded-full border-solid border-2 inline-block animate-spin",
		style: {
			width: e,
			height: e,
			borderColor: "rgba(0, 0, 0, 0.26) rgba(0, 0, 0, 0.26) transparent"
		}
	});
}
//#endregion
//#region src/components/button/button.tsx
var P = u(({ loading: e = !1, backgroundColor: t = "#000000", forgroundColor: r = "#ffffff", showBorder: i = !1, style: a, className: o, ...s }, c) => {
	let { disabled: l = !1, children: u } = s;
	return /* @__PURE__ */ n("button", {
		className: O("relative overflow-hidden rounded-xl cursor-pointer text-base font-bold px-6.5 w-full min-h-12.75 text-center transition-shadow duration-150 ease-[cubic-bezier(0.2,0,0,1)] outline-offset-2 pointer-hover:hover:shadow-hover", e ? "py-2.5 select-none cursor-default pointer-events-none text-black/25 bg-black/12 shadow-none border-0" : O("py-3.75", i && !l && "[border-style:groove] border border-black", i && l && "border-0", !i && "border-0"), o),
		style: e ? a : {
			backgroundColor: l ? "rgba(0,0,0,0.10)" : t,
			color: r,
			...a
		},
		type: "button",
		disabled: l,
		"aria-disabled": l,
		title: e ? "loading" : "",
		ref: c,
		...s,
		children: e ? /* @__PURE__ */ n(N, {}) : u
	});
});
P.displayName = "Button";
//#endregion
//#region src/components/small-button/small-button.tsx
var F = u(({ showBorder: e = !1, className: t, ...r }, i) => {
	let { disabled: a = !1, children: o } = r;
	return /* @__PURE__ */ n("button", {
		className: O("relative overflow-hidden text-black text-sm font-bold cursor-pointer w-auto text-center transition-shadow duration-150 ease-[cubic-bezier(0.2,0,0,1)] outline-offset-2", e ? "bg-white rounded-lg border border-black/10 px-3 py-3" : "bg-white rounded-xl border-0 px-2.5 py-1.25 shadow-hover", a && "bg-disabled", t),
		type: "button",
		disabled: a,
		"aria-disabled": a,
		ref: i,
		...r,
		children: o
	});
});
F.displayName = "SmallButton";
//#endregion
//#region src/components/arrow-button/arrow-button.tsx
var I = u(({ arrowDirection: e, altText: t, children: i, className: a, ...o }, s) => {
	let { disabled: c = !1 } = o;
	return /* @__PURE__ */ n("button", {
		type: "button",
		disabled: c,
		className: O("relative overflow-hidden cursor-pointer text-left bg-white text-black text-sm min-h-0 p-2 max-w-fit w-auto rounded-xl border border-black transition-shadow duration-150 ease-[cubic-bezier(0.2,0,0,1)] outline-offset-2 active:border-0 pointer-hover:hover:shadow-hover", a),
		tabIndex: 0,
		"aria-disabled": c,
		ref: s,
		...o,
		style: {
			opacity: c ? "20%" : "100%",
			...o.style
		},
		children: /* @__PURE__ */ r("div", {
			className: "flex flex-row items-center justify-between w-full mx-0.5",
			children: [/* @__PURE__ */ n("span", { children: i }), /* @__PURE__ */ n("img", {
				src: h,
				alt: t,
				className: O("relative h-4 w-4 ml-1.5 p-0", e === "UP" ? "rotate-0" : "rotate-180")
			})]
		})
	});
});
I.displayName = "ArrowButton";
//#endregion
//#region src/components/error-text/error-text.tsx
function ie({ children: e }) {
	return /* @__PURE__ */ n("div", {
		className: "text-sm mt-2 mb-6 text-error bg-transparent w-full text-center",
		children: e
	});
}
//#endregion
//#region src/components/headline/headline.tsx
function ae({ children: e, className: t, ...r }) {
	return /* @__PURE__ */ n("h1", {
		className: O("text-black font-normal text-3xl leading-normal mb-4 whitespace-pre-line text-left", t),
		id: "mySectionHeading",
		...r,
		children: e
	});
}
function oe({ children: e, className: t, ...r }) {
	return /* @__PURE__ */ n("h2", {
		className: O("text-black font-bold text-base leading-normal m-0 whitespace-pre-line text-left", t),
		id: "mySecondarySectionHeading",
		...r,
		children: e
	});
}
//#endregion
//#region src/components/icon-button/toggle-icon-button.tsx
var L = u(({ activationStatus: e, iconSrc: t, iconSrcOnDeactivate: r, altText: i, ...a }, o) => /* @__PURE__ */ n("button", {
	className: O("border-0 hover:cursor-pointer px-2.5 py-1.25 w-auto shadow-hover rounded-xl flex items-center justify-center text-center", e ? "bg-success" : "bg-white"),
	type: a.type === "submit" ? "submit" : "button",
	ref: o,
	...a,
	children: /* @__PURE__ */ n("img", {
		src: r && !e ? r : t,
		alt: i
	})
}));
L.displayName = "ToggleIconButton";
//#endregion
//#region src/components/input/input.tsx
function R({ type: e, onChange: t, value: i, error: a = !1, disabled: o, placeholder: s, crossClick: c, applyBackground: l = !1, showSearchIcon: u = !1, boarderOnFocus: f = !1, ariaLabel: p, crossAriaLabel: m, searchIconAlt: h }) {
	let _ = d((e) => {
		t(e.target.value);
	}, [t]);
	return /* @__PURE__ */ r("div", {
		className: "relative inline-flex items-center w-full",
		children: [
			/* @__PURE__ */ n("input", {
				tabIndex: 0,
				className: O("block bg-transparent border-0 min-w-0 w-full h-10 rounded-lg leading-8.25 p-2 font-bold", "placeholder:font-normal", "focus:border-2 focus:border-black focus:p-1.5 focus:outline-none focus-visible:outline-none", l && !a && "bg-black/5", a && "bg-error/10", u && "pl-12.5", u && "focus:pl-12"),
				name: "subject",
				type: e,
				onChange: _,
				placeholder: s,
				disabled: o,
				value: i,
				"aria-label": p,
				"aria-disabled": o
			}),
			u ? /* @__PURE__ */ n("div", {
				className: "absolute left-4 flex items-center",
				children: /* @__PURE__ */ n("img", {
					src: g,
					alt: h,
					className: "h-full w-full aspect-square object-cover rounded"
				})
			}) : void 0,
			a ? /* @__PURE__ */ n("div", {
				className: "absolute right-3 flex items-center text-error ml-2",
				onClick: c,
				role: "button",
				tabIndex: 0,
				"aria-label": m,
				onKeyDown: (e) => {
					(e.key === "Enter" || e.key === " ") && c();
				},
				children: /* @__PURE__ */ n("svg", {
					width: "24",
					height: "24",
					viewBox: "0 0 24 24",
					xmlns: "http://www.w3.org/2000/svg",
					children: /* @__PURE__ */ n("g", { children: /* @__PURE__ */ n("path", {
						d: "M 13.057 12 L 17.249 16.192 L 16.192 17.25 L 11.999 13.057 L 7.807 17.25 L 6.749 16.192 L 10.942 12 L 6.749 7.807 L 7.807 6.75 L 11.999 10.942 L 16.192 6.75 L 17.249 7.807 L 13.057 12 Z M 12 0 C 5.373 0 0 5.373 0 12 C 0 18.627 5.373 24 12 24 C 18.627 24 24 18.627 24 12 C 24 5.373 18.627 0 12 0 Z",
						fill: "currentColor",
						fillRule: "evenodd"
					}) })
				})
			}) : void 0
		]
	});
}
//#endregion
//#region src/components/loader/loader.tsx
function z({ delay: e }) {
	return /* @__PURE__ */ n("div", {
		className: "w-4 h-4 bg-black rounded-full mx-1.5 animate-blink",
		style: { animationDelay: e }
	});
}
function B() {
	return /* @__PURE__ */ r("div", {
		className: "flex items-center",
		children: [
			/* @__PURE__ */ n(z, { delay: "0s" }),
			/* @__PURE__ */ n(z, { delay: "0.2s" }),
			/* @__PURE__ */ n(z, { delay: "0.4s" })
		]
	});
}
function V() {
	return /* @__PURE__ */ n("div", {
		className: "flex justify-center h-dvh",
		children: /* @__PURE__ */ n(B, {})
	});
}
//#endregion
//#region src/components/text/text.tsx
function H({ capitalizeFirst: e = !1, children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		className: O("text-black font-normal text-base leading-5.25 mt-2 bg-transparent [&_strong]:underline [&_strong]:underline-offset-sm", e && "first-letter:capitalize", r),
		...i,
		children: t
	});
}
//#endregion
//#region src/components/text-button/text-button.tsx
var U = u(({ children: e, className: t, ...r }, i) => /* @__PURE__ */ n("button", {
	className: O("border-0 bg-transparent text-black font-normal text-base leading-4.75 text-center underline underline-offset-sm mt-8 mb-4 hover:cursor-pointer outline-offset-2", t),
	type: "button",
	ref: i,
	...r,
	children: e
}));
U.displayName = "TextButton";
//#endregion
//#region src/components/age-restriction-modal/age-restriction-modal.tsx
function W({ proceed: e, title: t, description: i, acceptText: a }) {
	return /* @__PURE__ */ r("div", { children: [
		/* @__PURE__ */ n("div", {
			className: "font-bold text-black  text-xl mb-6 mt-6",
			children: t
		}),
		/* @__PURE__ */ n("div", {
			className: "font-normal text-black text-base leading-5.25 mb-6",
			children: i
		}),
		/* @__PURE__ */ n("div", {
			className: "pb-8",
			children: /* @__PURE__ */ n(P, {
				loading: !1,
				type: "submit",
				onClick: e,
				children: a
			})
		})
	] });
}
//#endregion
//#region src/components/comment-box/comment-box.tsx
function G({ onWritingComment: e, placeHolderText: t, ariaLabel: r }) {
	let [i, a] = m("");
	return /* @__PURE__ */ n("textarea", {
		tabIndex: 0,
		className: "h-35 block bg-black/5 border-2 border-transparent rounded-lg min-w-0 w-full p-4 placeholder:font-normal focus:border-black focus:outline-none",
		placeholder: t,
		value: i,
		onChange: (t) => {
			let n = t.target.value;
			a(n), e(n);
		},
		"aria-label": r
	});
}
//#endregion
//#region src/components/star-rating/star-rating.tsx
function K({ onRatingSelect: e, npsTitles: t, lowHighLabel: i, disableOnTap: a = !1, altImage: o }) {
	let [s, c] = m(0), l = (t) => {
		c(t + 1), e(t + 1);
	};
	return /* @__PURE__ */ r("div", {
		className: "min-h-25 w-fit",
		children: [
			/* @__PURE__ */ n("div", {
				className: "grid grid-cols-5 gap-6",
				children: Array.from({ length: 5 }).map((e, t) => /* @__PURE__ */ n("button", {
					type: "button",
					className: "bg-transparent border-0 max-h-16 max-w-16",
					onClick: () => {
						l(t);
					},
					tabIndex: 0,
					disabled: s > 0 ? a : !1,
					children: /* @__PURE__ */ n("img", {
						src: t < s ? v : _,
						alt: o,
						width: "100%"
					})
				}, `star-${t.toString()}`))
			}),
			t?.[s - 1] ? /* @__PURE__ */ n("div", {
				className: "text-black font-bold text-base leading-normal mt-4 text-center",
				children: t[s - 1]
			}) : void 0,
			i ? /* @__PURE__ */ r("div", {
				className: "font-normal text-xs leading-normal mt-2 flex flex-row justify-between items-center text-center text-black/50 whitespace-pre-wrap pl-1.25 pr-2.5",
				children: [/* @__PURE__ */ n("span", { children: i.low }), /* @__PURE__ */ n("span", { children: i.high })]
			}) : void 0
		]
	});
}
//#endregion
//#region src/components/segmented-button/segmented-button.tsx
function q({ options: e, selected: t, onSelect: i, smallContainer: a = !1, backgroundColor: o = "rgba(0, 0, 0, 0.05)", groupAriaLabel: s }) {
	let c = p(null), l = p([]);
	return f(() => {
		let n = e.findIndex((e) => e.value === t), r = l.current[n], i = c.current;
		if (r && i) {
			let { offsetLeft: e, offsetWidth: t } = r;
			i.style.width = `${t.toString()}px`, i.style.transform = `translateX(${e.toString()}px)`;
		}
	}, [t, e]), /* @__PURE__ */ n("div", {
		className: "flex my-2",
		children: /* @__PURE__ */ r(y.Root, {
			type: "single",
			value: t,
			onValueChange: (e) => {
				e && e !== t && i(e);
			},
			className: O("relative flex justify-between overflow-hidden w-full rounded-xl", a ? "p-1.5" : "p-3"),
			style: a ? {
				width: "100px",
				background: o
			} : { background: o },
			"aria-label": s,
			children: [/* @__PURE__ */ n("div", {
				ref: c,
				className: O("absolute left-0 z-0 w-0 bg-white shadow-hover rounded-lg transition-[transform,width] duration-300 ease", a ? "top-1 bottom-1" : "top-2 bottom-2")
			}), e.map((t, r) => /* @__PURE__ */ n(y.Item, {
				value: t.value,
				className: O("cursor-pointer flex justify-center items-center z-1 relative text-center transition-colors duration-300 ease font-normal focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-2", a ? "py-1 px-1 text-sm" : "py-2.5 px-2.5 text-base"),
				style: { width: `calc(97% / ${e.length})` },
				ref: (e) => {
					l.current[r] = e;
				},
				"aria-label": t.label,
				children: t.label
			}, t.value))]
		})
	});
}
//#endregion
//#region src/components/compare-ruler/compare-ruler.tsx
function se() {
	return /* @__PURE__ */ n("svg", {
		width: "10",
		height: "9",
		viewBox: "0 0 12 9",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ n("path", {
			d: "M5.20753 1.02937C5.60784 0.509358 6.39204 0.509358 6.79235 1.02937L11.6888 7.39001C12.195 8.04757 11.7262 9 10.8964 9H1.10351C0.273676 9 -0.195087 8.04757 0.31111 7.39001L5.20753 1.02937Z",
			fill: "#000"
		})
	});
}
function ce() {
	return /* @__PURE__ */ n("svg", {
		width: "10",
		height: "9",
		viewBox: "0 0 12 9",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ n("path", {
			d: "M6.79241 7.97063C6.3921 8.49064 5.6079 8.49064 5.20759 7.97063L0.311171 1.60999C-0.195026 0.952425 0.273738 0 1.10358 0L10.8964 0C11.7263 0 12.195 0.952425 11.6888 1.60999L6.79241 7.97063Z",
			fill: "#000"
		})
	});
}
function J({ startLabel: e, endLabel: t, arrowDown: i, arrowUp: a }) {
	let o = Math.floor((i.value + a.value) / 2 / 100 * 5), s = Array.from({ length: 5 }, (e, t) => `box-${(t + 1).toString()}`);
	return /* @__PURE__ */ r("div", {
		className: "grid grid-cols-[50px_auto_50px] w-full justify-items-center bg-transparent focus-visible:outline focus-visible:outline-blue-500",
		children: [
			/* @__PURE__ */ n("div", {
				className: "bg-transparent text-black font-normal text-xs overflow-hidden leading-7.5 content-center w-full text-left",
				children: e
			}),
			/* @__PURE__ */ r("div", {
				className: "relative grid grid-cols-5 gap-x-0.75 w-full @container",
				children: [
					s.map((e, t) => /* @__PURE__ */ n("div", { className: O("w-full h-1 bg-black self-center", o === t ? "opacity-100" : "opacity-10") }, e)),
					/* @__PURE__ */ r("div", {
						className: "absolute flex flex-col items-center transition-transform duration-300 ease-in-out -top-3",
						style: { transform: `translateX(calc(${i.value.toString()}cqw - 50%))` },
						children: [/* @__PURE__ */ n("span", {
							className: "text-black font-normal text-xs",
							children: i.label
						}), /* @__PURE__ */ n(ce, {})]
					}),
					/* @__PURE__ */ r("div", {
						className: "absolute flex flex-col items-center transition-transform duration-300 ease-in-out top-4.5",
						style: { transform: `translateX(calc(${a.value.toString()}cqw - 50%))` },
						children: [/* @__PURE__ */ n(se, {}), /* @__PURE__ */ n("span", {
							className: "text-black font-normal text-xs",
							children: a.label
						})]
					})
				]
			}),
			/* @__PURE__ */ n("div", {
				className: "bg-transparent text-black font-normal text-xs overflow-hidden leading-7.5 content-center w-full text-right",
				children: t
			})
		]
	});
}
//#endregion
//#region src/components/measurement-box/measurement-box.tsx
function le({ title: e, compareData: t, measurementData: i, marginBottom: a = "0px", marginTop: o = "0px" }) {
	return /* @__PURE__ */ n(k, {
		backgroundColor: "white",
		applyBorder: !0,
		marginBottom: a,
		marginTop: o,
		children: /* @__PURE__ */ r("div", {
			className: "flex flex-col w-full",
			children: [
				/* @__PURE__ */ n("div", {
					className: "font-bold text-black text-base flex flex-row justify-center mb-5",
					children: e
				}),
				t ? /* @__PURE__ */ n("div", {
					className: "w-full",
					children: /* @__PURE__ */ n(J, {
						startLabel: t.startLabel,
						endLabel: t.endLabel,
						arrowUp: t.arrowUp,
						arrowDown: t.arrowDown
					})
				}) : void 0,
				i ? /* @__PURE__ */ r("div", {
					className: "flex flex-row items-center self-center",
					children: [
						/* @__PURE__ */ r("div", {
							className: "flex flex-col items-center text-black",
							children: [/* @__PURE__ */ n("span", {
								className: "text-xs",
								children: i.left.label
							}), /* @__PURE__ */ n("span", {
								className: "text-base font-bold",
								children: i.left.value
							})]
						}),
						/* @__PURE__ */ n("div", { className: "w-0.75 h-full opacity-10 rounded-3xl bg-black self-center mx-10" }),
						/* @__PURE__ */ r("div", {
							className: "flex flex-col items-center text-black",
							children: [/* @__PURE__ */ n("span", {
								className: "text-xs",
								children: i.right.label
							}), /* @__PURE__ */ n("span", {
								className: "text-base font-bold",
								children: i.right.value
							})]
						})
					]
				}) : void 0
			]
		})
	});
}
//#endregion
//#region src/components/box-with-colored-header/box-with-colored-header.tsx
function ue({ children: e, title: t, alignItems: i = "center" }) {
	return /* @__PURE__ */ r("div", {
		className: "bg-transparent flex flex-col items-start rounded-xl border border-black/10",
		children: [/* @__PURE__ */ n("div", {
			className: "w-full rounded-t-xl py-4 bg-scanner-accent flex flex-row items-center justify-center",
			children: t
		}), /* @__PURE__ */ n("div", {
			className: "w-full py-6 flex flex-col bg-transparent",
			style: { alignItems: i },
			children: e
		})]
	});
}
//#endregion
//#region src/util/utils.ts
var de = () => /Mobi/i.test(globalThis.navigator.userAgent) || !window.matchMedia("(any-hover: hover)").matches, fe = (e) => e ? /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/.test(e) : !1;
function Y(e) {
	return pe.get(e) ?? e;
}
var pe = new Map([
	["EU", "EU"],
	["UK", "UK"],
	["US", "US"],
	["US_WOMEN", "US Women"],
	["US_MEN", "US Men"],
	["MONDOPOINT", "Mondopoint"],
	["AU_WOMEN", "AU Women"],
	["AU_MEN", "AU Men"],
	["SKATE_SIZE", "Skate Size"]
]);
//#endregion
//#region src/components/size-table/utils.ts
function X(e) {
	let t = e * 1e3;
	return String(Math.round(t) / 10);
}
function Z(e) {
	let t = e * 39.3701;
	return String(Math.round(t * 10) / 10);
}
function Q(e, t) {
	return t === "inches" ? `${Z(e.min)} - ${Z(e.max)}` : `${X(e.min)} - ${X(e.max)}`;
}
function $(e) {
	return e.every((e) => e.footWidth !== void 0);
}
//#endregion
//#region src/components/size-table/size-table.tsx
function me({ sizeList: e, lengthUnit: t, lengthTitle: i, widthTitle: a, sizeLocale: o }) {
	return /* @__PURE__ */ r("table", {
		className: "w-full border-collapse table-fixed text-sm text-center",
		children: [/* @__PURE__ */ n("thead", {
			className: "sticky top-0 z-2 bg-white outline-1 outline-white",
			children: /* @__PURE__ */ r("tr", { children: [
				/* @__PURE__ */ n("th", {
					className: "bg-table-header px-3 py-4.75 font-bold first:rounded-tl-xl last:rounded-tr-xl",
					children: i
				}),
				$(e) ? /* @__PURE__ */ n("th", {
					className: "bg-table-header px-3 py-4.75 font-bold first:rounded-tl-xl last:rounded-tr-xl",
					children: a
				}) : void 0,
				/* @__PURE__ */ n("th", {
					className: "bg-table-header px-3 py-4.75 font-bold first:rounded-tl-xl last:rounded-tr-xl",
					children: Y(o)
				})
			] })
		}), /* @__PURE__ */ n("tbody", {
			className: "border border-black/10",
			children: e.map((i, a) => /* @__PURE__ */ r("tr", { children: [
				/* @__PURE__ */ n("td", {
					className: "font-normal px-3 py-4.75 border-b border-black/10",
					children: Q(i.footLength, t)
				}),
				$(e) ? /* @__PURE__ */ n("td", {
					className: "font-normal px-3 py-4.75 border-b border-black/10",
					children: Q(i.footWidth, t)
				}) : void 0,
				/* @__PURE__ */ n("td", {
					className: "font-normal px-3 py-4.75 border-b border-black/10",
					children: i.localizedSizes.find((e) => e.locale === o)?.label
				})
			] }, a))
		})]
	});
}
//#endregion
//#region src/components/progress-bar/progress-bar.tsx
function he({ activeStep: e, stepsCount: t }) {
	return /* @__PURE__ */ n("div", {
		className: "flex flex-row content-between bg-transparent w-full gap-2",
		children: Array.apply(0, Array.from({ length: t })).map((t, r) => /* @__PURE__ */ n("div", { className: O("grow h-1 rounded-lg bg-black", r !== e && "opacity-10") }, r))
	});
}
//#endregion
//#region src/components/button-grid-view/button-grid-view.tsx
function ge({ options: e, selected: t, onSelect: r, groupAriaLabel: i, singleColumnMode: a = !1 }) {
	return /* @__PURE__ */ n("div", {
		className: O("grid grid-auto-flow-row overflow-y-auto overflow-x-hidden", a ? "grid-cols-1 gap-4" : "grid-cols-auto-fit-100 xs:grid-cols-auto-fit-120 gap-2"),
		"aria-label": i,
		children: e.map((e) => /* @__PURE__ */ n("button", {
			className: O("bg-white rounded-xl text-center transition-transform duration-200 ease-in-out hover:cursor-pointer border", t && t === e.value ? "border-black" : "border-black/10", a ? "px-4 py-6" : "p-4"),
			onClick: () => {
				r(e.value);
			},
			type: "button",
			children: /* @__PURE__ */ n("div", {
				className: "flex items-center justify-center text-base text-black first-letter:capitalize",
				children: e.label
			})
		}, e.label))
	});
}
//#endregion
//#region src/components/banner-image/banner-image.tsx
function _e({ src: e, alt: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		className: O("w-full flex flex-row min-h-32 min-w-32 max-h-100 justify-center self-center justify-self-center", r),
		...i,
		children: /* @__PURE__ */ n("img", {
			src: e,
			className: "w-full h-full object-cover rounded-2xl",
			alt: t
		})
	});
}
//#endregion
//#region src/components/drop-down/drop-down.tsx
function ve({ options: e, selected: t, btAlt: i, selectedItemAlt: a, onSelect: o, groupAriaLabel: s }) {
	let c = e.find((e) => e.value === t) ?? {
		value: t,
		label: t
	};
	return /* @__PURE__ */ r(b.Root, {
		value: t,
		onValueChange: o,
		children: [/* @__PURE__ */ n(b.Trigger, {
			asChild: !0,
			children: /* @__PURE__ */ n(I, {
				arrowDirection: "DOWN",
				className: "border-black/10 w-full max-w-full",
				altText: i,
				"aria-label": t,
				children: c.label
			})
		}), /* @__PURE__ */ n(b.Portal, { children: /* @__PURE__ */ n(b.Content, {
			className: "bg-white border border-black rounded-xl py-1 shadow-hover overflow-y-auto z-10 w-(--radix-select-trigger-width)",
			position: "popper",
			sideOffset: 10,
			"aria-label": s,
			children: /* @__PURE__ */ n(b.Viewport, { children: e.map((t, i) => /* @__PURE__ */ r(b.Group, { children: [/* @__PURE__ */ r(b.Item, {
				value: t.value,
				className: "relative flex items-center px-4 py-2.5 text-sm border-none text-black text-left cursor-pointer justify-between",
				children: [/* @__PURE__ */ n(b.ItemText, { children: t.label }), /* @__PURE__ */ n(b.ItemIndicator, { children: /* @__PURE__ */ n("img", {
					src: x,
					alt: a,
					className: "w-4 h-4"
				}) })]
			}), i < e.length - 1 && /* @__PURE__ */ n(b.Separator, { className: "h-px w-full bg-black/10" })] }, t.label)) })
		}) })]
	});
}
//#endregion
//#region src/components/disabled-stars/disabled-star.tsx
function ye({ rate: e, altText: t }) {
	return /* @__PURE__ */ n("div", {
		className: "flex flex-row w-fit gap-1",
		children: Array.from({ length: 5 }).map((r, i) => /* @__PURE__ */ n("div", {
			className: O(i < e ? "opacity-100" : "opacity-10"),
			children: /* @__PURE__ */ n("img", {
				src: S,
				alt: t,
				width: "100%"
			})
		}, `star-${i.toString()}`))
	});
}
//#endregion
//#region src/components/highlight-box/highlight-box.tsx
function be({ children: e, iconSrc: t, iconAlt: i, marginTop: a = "16px" }) {
	return /* @__PURE__ */ n(k, {
		backgroundColor: w.styles.colors.hint,
		alignItems: "left",
		padding: "16px",
		marginBottom: "0px",
		marginTop: a,
		children: /* @__PURE__ */ r("div", {
			className: "flex flex-row items-center justify-start",
			children: [/* @__PURE__ */ n("img", {
				src: t,
				className: "pr-4",
				alt: i
			}), e]
		})
	});
}
//#endregion
//#region src/components/highlight-bar/highlight-bar.tsx
function xe({ children: e }) {
	return /* @__PURE__ */ r("div", {
		className: "flex flex-row",
		children: [/* @__PURE__ */ n("span", { className: "w-1 rounded-xs bg-hint mr-2" }), e]
	});
}
//#endregion
//#region src/components/scan-list/scan-item.tsx
function Se({ item: e, isSelected: t, title: i, checkAlt: a }) {
	return /* @__PURE__ */ n(C.Item, {
		className: O("flex flex-row items-center justify-between h-21 bg-white rounded-xl my-4 cursor-pointer", t ? "border-2 border-black" : "border border-black/10 p-px"),
		"aria-label": i,
		value: e.id,
		asChild: !0,
		children: /* @__PURE__ */ r("li", {
			className: "list-none",
			children: [/* @__PURE__ */ r("div", {
				className: "flex flex-col items-start justify-center ml-5",
				children: [/* @__PURE__ */ n("div", {
					className: "ml-2.5 font-bold leading-6",
					children: i
				}), /* @__PURE__ */ n("div", {
					className: "mt-1 ml-2.5 font-normal text-xs leading-4.5 text-black",
					children: new Date(e.createdAt).toLocaleString(globalThis.navigator.language)
				})]
			}), /* @__PURE__ */ n("div", {
				className: "relative self-center mr-6 h-6 w-6",
				children: /* @__PURE__ */ n("div", {
					className: O("rounded-full h-5 w-5 absolute left-0 top-0 border-2 flex items-center justify-center", t ? "bg-success border-success" : "bg-white border-black"),
					children: /* @__PURE__ */ n("img", {
						className: O(t ? "visible" : "invisible"),
						src: ee,
						alt: a
					})
				})
			})]
		})
	});
}
//#endregion
//#region src/components/scan-list/scan-list.tsx
function Ce({ items: e, selectedId: t, onSelect: r, titles: i, selectIconAlt: a }) {
	return /* @__PURE__ */ n(C.Root, {
		className: "ml-0 pl-0 overflow-y-auto",
		value: t,
		onValueChange: r,
		asChild: !0,
		children: /* @__PURE__ */ n("ul", { children: e.map((e) => /* @__PURE__ */ n(Se, {
			item: e,
			isSelected: e.id === t,
			title: e.type === "RetailScan" ? i.instore : i.webscanner,
			checkAlt: a
		}, e.id)) })
	});
}
//#endregion
//#region src/components/pill-selector/pill-selector.tsx
function we({ options: e, selected: t, onSelect: r, groupAriaLabel: i }) {
	return /* @__PURE__ */ n("div", {
		className: "flex my-2",
		children: /* @__PURE__ */ n(y.Root, {
			type: "single",
			value: t,
			onValueChange: (e) => {
				e && r(e);
			},
			className: "inline-flex gap-2 mx-auto w-full",
			"aria-label": i,
			children: e.map((e) => /* @__PURE__ */ n(y.Item, {
				value: e.value,
				className: "cursor-pointer px-4 py-2 rounded-full text-sm font-normal text-center transition-all duration-200 ease-in-out border border-black/10 bg-white text-black hover:border-black/30 focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-2 data-[state=on]:bg-black data-[state=on]:text-white data-[state=on]:border-black",
				"aria-label": e.label,
				children: e.label
			}, e.value))
		})
	});
}
//#endregion
//#region src/components/list-grid/list-grid.tsx
function Te({ options: e, selected: t, onSelect: i, checkMarkAltText: a, groupAriaLabel: o }) {
	let s = l();
	return f(() => {
		s.current && t && s.current.focus();
	}, [s, t]), /* @__PURE__ */ n("div", {
		className: "flex flex-auto flex-col grow overflow-y-scroll mt-2.5 mb-2.5",
		"aria-label": o,
		children: e.map((o, s) => /* @__PURE__ */ r(c, { children: [/* @__PURE__ */ r("button", {
			className: "m-px relative overflow-hidden cursor-pointer min-h-12.75 bg-white flex items-center text-base pl-4 border-transparent",
			type: "button",
			onClick: () => {
				i(o.value);
			},
			children: [/* @__PURE__ */ n(H, { children: o.label }), t === o.value && /* @__PURE__ */ n("div", {
				className: "absolute right-[5%] max-h-6.25 max-w-6.25",
				children: /* @__PURE__ */ n("img", {
					src: x,
					alt: a,
					className: "h-full w-full aspect-square object-cover rounded"
				})
			})]
		}), s !== e.length - 1 && /* @__PURE__ */ n("div", { className: "h-px min-h-px w-full bg-black/10" })] }, o.label))
	});
}
function Ee({ options: e, selected: i, onSelect: a, placeHolder: o, groupAriaLabel: s, noMatchDescription: c, noMatchTitle: l, ariaSearchLabel: u, checkMarkAltText: d, crossAriaLabel: f, searchIconAlt: p }) {
	let [h, g] = m(e), [_, v] = m("");
	return /* @__PURE__ */ r(t, { children: [
		/* @__PURE__ */ n(R, {
			value: _,
			onChange: (t) => {
				v(t), g(e.filter((e) => e.label.toLowerCase().includes(t.toLowerCase()) || e.value.toLowerCase().includes(t.toLowerCase())));
			},
			applyBackground: !0,
			type: "search",
			boarderOnFocus: !0,
			showSearchIcon: !0,
			crossClick: () => {
				v("");
			},
			placeholder: o,
			ariaLabel: u,
			crossAriaLabel: f,
			searchIconAlt: p
		}),
		h.length === 0 && /* @__PURE__ */ r(k, { children: [/* @__PURE__ */ n("span", {
			className: "font-bold text-xl opacity-50",
			children: `${l}"${_}"`
		}), /* @__PURE__ */ n("span", {
			className: "font-normal text-base opacity-50 pt-4",
			children: c
		})] }),
		/* @__PURE__ */ n(Te, {
			options: h,
			selected: i,
			onSelect: a,
			groupAriaLabel: s,
			checkMarkAltText: d
		})
	] });
}
//#endregion
export { W as AgeRestrictionModal, I as ArrowButton, ne as BackDrop, _e as BannerImage, k as BoxContainer, ue as BoxWithColoredHeader, T as BrandingFooter, P as Button, ge as ButtonGridView, G as CommentBox, J as CompareRuler, A as Container, re as Content, ye as DisabledStar, ve as Dropdown, ie as ErrorText, M as Header, ae as Headline, oe as Headline2, xe as HighlightBar, be as HighlightBox, j as IconButton, R as Input, Ee as ListGridSearchBar, V as Loader, B as LoaderDots, le as MeasurementBox, we as PillSelector, te as PrivacyBox, D as PrivacyTerms, he as ProgressBar, Ce as ScanList, q as SegmentedButton, me as SizeTable, F as SmallButton, N as Spinner, K as StarRating, H as Text, U as TextButton, L as ToggleIconButton, O as cn, Y as formatLocale, de as isMobileDevice, fe as isValidEmail, w as uiConfig };
